var uAjax = "/index.cfm/adcount/ajax";

$(function()
{
	$(el("mainContainer")).on("submit","#adCountLoginFrm", function(e)
	{
		e.preventDefault();

		adCountLoginSubmit();
	});

	$(el("mainContainer")).on("submit","#adCountRequestPasswordFrm", function(e)
	{
		e.preventDefault();

		adCountRequestPasswordSubmit();
	});

	$(el("mainContainer")).on("change",".inputStoreId", function()
	{
		adCountSelectStore($(this).val());
	});

	$(el('mainContainer')).on('click', '.createAdcountAppointmentProgressActions .stepAction', function(e)
	{
		e.preventDefault();
		adcountAppointmentStepActionHandler($(this));
	});
});

function adcountAppointment()
{
	$(".createAdcountAppointmentProgressActions .stepAction").prop("disabled", true);

	var sParams = getValues($("#createAdcountAppointmentFrm"));
	var oCall   = callAjax("appointment", sParams, "post", uAjax + "/appointment");
	oCall.success(function(oData)
	{
		if(oData.errorType == "")
		{
			adcountAppointmentStepProgress(5);
			$(".createAdcountAppointmentProgressActions .stepAction[data-direction='down']").remove();
			$(".createAdcountAppointmentProgressActions .stepAction").prop("disabled", false);
		}
		else
		{
			$(".createAdcountAppointmentProgressActions .stepAction").prop("disabled", false);

			showAlert("error", oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function adcountAppointmentStepActionHandler(oBtn)
{
	var bValid = true;
	var iCurrentStep = parseInt(oBtn.data("currentStep"));
	var sDirection   = oBtn.data("direction");

	if(sDirection == "up")
	{
		bValid = validateVisibleFormFields();
	}

	if(bValid)
	{
		if((iCurrentStep == 1 && sDirection == "down") || (iCurrentStep == 5 && sDirection == "up"))
		{
			window.location = '/' + sCurrentLanguageCode + '/adcount';
		}
		else if(iCurrentStep == 4 && sDirection == "up")
		{
			adcountAppointment();
		}
		else
		{
			iCurrentStep = (sDirection == "up") ? iCurrentStep+1 : iCurrentStep-1;
			adcountAppointmentStepProgress(iCurrentStep);
		}
	}
}

function adcountAppointmentStepProgress(iProgressStep)
{
	var oStep = $(".createAdcountAppointmentStep[data-step='" + iProgressStep + "']");
	var sTitle = oStep.data("title");
	$(".createAdcountAppointmentStep").toggleClass("hide",true);
	oStep.removeClass("hide");

	$(".createAdcountAppointmentProgressActions .stepAction").data("currentStep",iProgressStep);
	$(".createAdcountAppointmentProgress").find("h2").html(sTitle);
	$(".createAdcountAppointmentProgress").find('li').each(function()
	{
		$(this).removeClass("active");
		if(parseInt($(this).data("step")) <= iProgressStep)
		{
			$(this).addClass("active");
		}
	});

	if(iProgressStep == 3)
	{
		$('.inputStoreId').trigger("change");
	}
}

function adCountLoginSubmit()
{
	$(el('adCountLoginFrmSubmit')).prop('disabled',true);

	var oFrm= $(el("adCountLoginFrm"));
	var bValid = validateForm(oFrm);
	if(bValid)
	{
		var sParams = getValues(oFrm);
		var oCall   = callAjax("login", sParams, "post", uAjax + "/login");

		oCall.success(function(oData)
		{
			if(oData.errorType == "")
			{
				window.location = '/' + sCurrentLanguageCode + '/adcount';
			}
			else
			{
				$(el('adCountLoginFrmSubmit')).prop('disabled',false);
				inlineAlert('error', oData.errorMessage, oData.errorUnhandled, oFrm.find('#adCountLoginFrmSubmit'),false);
			}
		});
	}
	else
	{
		$(el('adCountLoginFrmSubmit')).prop('disabled',false);
	}
}

function adCountRequestPasswordSubmit()
{
	$(el('adCountRequestPasswordFrmSubmit')).prop('disabled',true);

	var oFrm= $(el("adCountRequestPasswordFrm"))
	var bValid = validateForm(oFrm);
	if(bValid)
	{
		var sParams = getValues(oFrm);
		var oCall   = callAjax("resetPassword", sParams, "post", uAjax + "/resetpassword");
		oCall.success(function(oData)
		{
			if(oData.errorType == "")
			{
				showAlert('success', "{sent}", false);
				setTimeout(function() {
					window.location = '/' + sCurrentLanguageCode + '/adcount';
				}, 2000);
			}
			else
			{
				$(el('adCountRequestPasswordFrmSubmit')).prop('disabled',false);

				showAlert("error", oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
	else
	{
		$(el('adCountRequestPasswordFrmSubmit')).prop('disabled',false);
	}
}

function adCountSelectStore(sStoreId)
{
	var oInputDate = $(".inputDate");

	if(typeof oInputDate.data("datepicker") !== "undefined" && oInputDate.data("datepicker").selectedDay != 0)
	{
		oSelectedDate = oInputDate.datepicker("getDate");
	}

	oInputDate.datepicker("destroy").val("").addClass("loading");
	$(".createAdcountAppointmentProgressActions .stepAction").prop("disabled", true);
	var sParams = getValues($(".adcountActionsWrapper"));
	sParams += "&storeId=" + sStoreId;
	var oCall   = callAjax("appointmentDates", sParams, "post", uAjax + "/appointmentdates");

	oCall.success(function(oData)
	{
		if(oData.errorType == "")
		{
			var jsDates = [];
			$.each(oData.dates, function(index, date)
			{
				if(!date.unavailable)
				{
					jsDates.push(date.date.replace(/(^|-)0+/g, "$1"));
				}
			});

			$(".inputDate").datepicker(
			{
				dateFormat: "dd-mm-yy",
				beforeShowDay: function(date)
				{
					return setAvailableDates(date,jsDates);
				}
			});

			if(typeof oSelectedDate !== "undefined" && typeof oSelectedDate !== null)
			{
				if(setAvailableDates(new Date(oSelectedDate),jsDates)[0])
				{
					$(".inputDate").datepicker("setDate",oSelectedDate);
				}
			}

			$(".inputDate").removeClass("loading");
			$(".createAdcountAppointmentProgressActions .stepAction").prop("disabled", false);
		}
		else
		{
			$(".inputDate").removeClass("loading");
			$(".createAdcountAppointmentProgressActions .stepAction").prop("disabled", false);

			showAlert("error", oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function setAvailableDates(oDate,aDates)
{
	var sDate = oDate.getFullYear() + "-" + (oDate.getMonth()+1) + "-" + oDate.getDate();

	if ($.inArray(sDate, aDates) != -1) {
	  return [true, "","Available"];
	} else {
	  return [false,"",sDate+"unAvailable for:" + aDates];
	}
}

function validateVisibleFormFields()
{
	var oVisibleStep = $(".createAdcountAppointmentStep").filter(function() {
		return !($(this).css("visibility") == "hidden");
	});

	return validateForm(oVisibleStep);
}